// Backend API Base URL
// Update this to match your backend server URL
// const baseUrl = 'http://localhost:4500';
const baseUrl = "https://bullet-api.shypv.com";

export default baseUrl;
